// Service tier → Salesforce Opportunity RecordTypeId mapping.
//
// SF Record Type drives the post-close-won automation, so when a user
// changes a prospect's service tier in our app we PUSH the corresponding
// RecordTypeId up to SF so the right downstream automation fires.
//
// To find or change these IDs:
//   SF → Setup → Object Manager → Opportunity → Record Types
//   click into the type → ID is in the URL (looks like 0121U000000abcDEF)

export const SF_RECORD_TYPE_BY_TIER = {
  // BWM — Financial Planning record covers Guided + Total Wealth
  'guided-wealth':   '0124x0000002MzxAAE',
  'total-wealth':    '0124x0000002MzxAAE',
  // BWM — Investment-Only is its own record type
  'investment-only': '0124x0000002N02AAE',
  // BWM — Tax Plan is its own record type (one-time engagement, not subscription)
  'tax-plan':        '012PA000002temrYAA',
  // BTS — Tax Prep record covers individual + business prep + bookkeeping
  'tax-individual':  '0124x0000002MzsAAE',
  'tax-business':    '0124x0000002MzsAAE',
  'business-package':'0124x0000002MzsAAE',
  'bookkeeping':     '0124x0000002MzsAAE',
  // BIA — Insurance
  'insurance':       '012PA000002tfcTYAQ',
};

export function getRecordTypeIdForTier(tier) {
  if (!tier) return null;
  return SF_RECORD_TYPE_BY_TIER[tier] || null;
}
